import { action, observable, reaction, makeObservable } from 'mobx';
import {Disposers} from '../../helpers';
import {ModalMessage} from './modal-message';
import {modalMessageService} from './ModalMessageService';

export class ModalMessageComponentStore {
  @observable
  isOpen: boolean;
  @observable.ref
  message: ModalMessage | null;
  @observable
  confirmed: boolean;

  private readonly disposers = new Disposers();

  constructor() {
    makeObservable(this);
    this.setup();
    this.message = null;
    this.isOpen = false;
    this.confirmed = false;
  }

  private setup() {
    this.disposers.add(reaction(
      () => modalMessageService.message,
      () => {
        const message = modalMessageService.message;
        this.message = message;
        this.isOpen = false;
        this.confirmed = false;
        if (message !== null)
          this.isOpen = true;
      },
      {fireImmediately: true}
    ));
  }

  @action
  close = () => {
    this.isOpen = false;
  };

  @action
  confirm = () => {
    this.close();
    this.confirmed = true;
  };

  @action
  cancel = () => {
    this.close();
  };

  @action
  onModalClosed = () => {
    if (this.confirmed)
      this.onModalConfirmed();
    if (!this.confirmed)
      this.onModalCancelled();
  };

  private onModalConfirmed() {
    if (this.message?.modalType === 'prompt')
      this.message.confirmAction();
    modalMessageService.clear();
    return;
  }

  private onModalCancelled() {
    if (this.message?.modalType === 'prompt')
      this.message.cancelAction();
    modalMessageService.clear();
    return;
  }

  dispose = () => {
    this.disposers.dispose();
  };
}
